var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTc = function SvgIconTc(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12C0 12.003 12 .001 12 0c6.627 0 12 5.373 12 12"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#F0F0F0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M11.969 12H12v-.033z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.001 6.261V.001h-.002C5.372 0 .001 5.372.001 12h6.26V8.474L9.788 12h2.182l.032-.032V9.787L8.475 6.26z"
  })), /*#__PURE__*/React.createElement("g", {
    fill: "#D80027"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M6.071 1.565a12.06 12.06 0 0 0-4.506 4.506v5.93h3.13V4.695H12v-3.13z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 10.524 7.738 6.261H6.262L12 12z"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#FFDA44",
    d: "M13.565 6.26V12c0 2.795 3.653 3.652 3.653 3.652S20.87 14.795 20.87 12V6.26z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FF9811",
    d: "M16.695 8.348c0 .576-.467 2.087-1.043 2.087s-1.044-1.511-1.044-2.087 1.044-1.044 1.044-1.044 1.043.467 1.043 1.044"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#A2001D",
    d: "M19.464 9.484c.169-.41.3-1.011.3-1.31 0-.48-.627-.87-.627-.87s-.626.39-.626.87c0 .299.131.9.3 1.31l-.362.816a1.83 1.83 0 0 0 1.377 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#6DA544",
    d: "M16.435 12s-.522 1.043-.522 2.087h2.609C18.522 13.044 18 12 18 12l-.783-.522z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M18 12v-.26a.783.783 0 0 0-1.564 0V12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgIconTc;